import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { HttpParams } from "@angular/common/http";
import { Params, Router } from "@angular/router";
import Swal from "sweetalert2";
import { ReportsService } from "src/app/features/reports/reports.service";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DialogComponent } from "src/app/features-common/components/dialog/dialog.component";
import { MatTabGroup } from "@angular/material/tabs";
import { CurrencyPipe, formatDate } from "@angular/common";
import * as moment from "moment";
import { JwtHelperService } from "@auth0/angular-jwt";
const helper = new JwtHelperService();


@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.scss'],
  providers: [CurrencyPipe],
})
export class RefundComponent
  extends FeaturesBaseComponent
  implements OnInit
{
  @Input() refund;
  @Input() summary;
  @Input() startDate;
  @Input() endDate;

  isRowSelected: boolean = false;
  searchValue: any;

  columnDefs: any;
  rowData: any = [];
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  isLogSelected: boolean;
  //summary:  Array<any>;

  minFromDate;
  maxDate;
  minToDate;
  userRole: string = "";
  
  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private currencyPipe: CurrencyPipe
  ) {
    super();
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
    this.setGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["refund"]) {
      this.refund = changes["refund"].currentValue;
      this.rowData = this.refund;
    }
    if (changes["summary"]) {
      this.summary = changes["summary"].currentValue;
    }
  }

  setGrid() {
    const self = this;
    this.columnDefs = [
      { field: "dateRequested", headerName: "Date Requested", width: 220,cellRenderer: (data) => {
        return moment(data.value).format("MM/DD/YYYY");
      }, },
      { field: "timeRequested", headerName: "Time Requested", width: 220,cellRenderer: (data) => {
        return moment(data.value).format("hh:mm:ss a");
      }, },
      { field: "amountPaid", headerName: "Refund Amount", width: 220,cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value);
      }, },
      { field: "retailerAccountNumber", headerName: "Retailer Account Number", width: 310 },
      { field: "retailerName", headerName: "Retailer Name", width: 220 },
      { field: "retialerAccountType", headerName: "Retailer Account Type", width: 270 },
      { field: "achBankAccountNumber", headerName: "ACH Bank Account Number", width: 300 },
      { field: "achRoutingNumber", headerName: "ACH Routing Number", width: 300 },
      { field: "bankName", headerName: "Bank Name", width: 210 },
      { field: "paymentStatus", headerName: "Refund Status", width: 330,
      cellRenderer: (params) => {
        return params.value == "Pending Approval"
          ? `${params.value} <span class="rounded-pill bg-info p-2 cur-point">Approve</span>`
          : params.value;
      },
      onCellClicked: function (params) {
        if (params.value == "Pending Approval") {
          self.handleApprove(params.data);
        }
      }, },
      { field: 'fileURL', headerName: 'File', width: 180, cellRenderer: (params) => { return params.data.fileURL && params.data.fileURL ? `Download` :"" },
      onCellClicked: function (params) { self.handleAttachment(params.data); }
      },
      { field: "paymentDttm", headerName: "Payment Date", width: 220,cellRenderer: (data) => {
        return moment(data.value).format("MM/DD/YYYY");
      }, },
      
    ];
    //this.rowData = []promoCodeGeneratedDate promoCodeSentDate promocodeReedemedDate promocodeEndDateTime
  }
  handleAttachment(data: any) {
    if(data.fileURL != null){
      window.open(data.fileURL)
    }    
  }   
  handleApprove(rowData) {
   
    if (rowData.retailerPaymentId && rowData.retailerPaymentId) {
      this.reportsService
        .approveACHDD(rowData.retailerPaymentId)
        .subscribe((res) => {
          if (res["httpcode"] == 200) {
            this.toastrService.success(`Payment Approved!`, `Success`);
            let params: any = new HttpParams()
              .set("startDate", this.startDate)
              .set("endDate", this.endDate);
            this.reportsService.getrefund(params).subscribe((res) => {
              let resData: any = res;
              if (resData.httpcode == 200) {
                resData = resData.data;
                this.refund = resData;
                this.rowData = this.refund;
              }
            });
          }
         
        });
    }
  }  
  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "refund-report.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if ((cellParams && cellParams.column.colId === "dateRequested") ||
      (cellParams && cellParams.column.colId === "paymentDttm")  ){
        return moment(cellParams.value).format("MM/DD/YYYY"); //apply your timestamp formatter
      }else if(cellParams && cellParams.column.colId === "timeRequested"
      ) {
        return moment(cellParams.value).format("hh:mm:ss a"); //apply your timestamp formatter
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (
      this.selectedRows &&
      this.selectedRows != [] &&
      this.selectedRows.length! > 0
    ) {
      this.isLogSelected = true;
      return;
    }
    this.isLogSelected = false;
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.startDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.endDate != null && this.endDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  changeToDate(e) {
    this.endDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.startDate != null && this.startDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  getDateChangeResult(startDate, endDate) {
    let params: any = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    this.reportsService.getrefundSummary(params).subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.summary = resData;
        this.reportsService.getrefund(params).subscribe((res) => {
          let resData: any = res;
          if (resData.httpcode == 200) {
            resData = resData.data;
            this.setRowData(res["data"]);
            this.refund = resData;
          }
        });
      }
    });
  }

  setRowData(rowData: any) {
    this.rowData = rowData;
  }
}
